import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-126e3eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compute-wizard-surface__label-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { IonText, IonItem, IonLabel, IonInput, alertController } from '@ionic/vue';
import { SurfaceGenericType } from '@/enums/Surface';
import { Icons } from '@/enums/Icons';
import { TranslateElement } from '@/types/TranslateElement';
import { useSurfaceStepStore } from '@/store/surfaceStep';
import useTranslateEnums from '@/composables/useTranslateEnums';
import ComputeWizardStepContainer from '@/components/ComputeWizard/ComputeWizardStepContainer.vue';
import SegmentSelect from '@/components/SegmentSelect.vue';
import ComputeWizardInputAccordion from '@/components/ComputeWizard/ComputeWizardInputAccordion.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import Bearing1 from '@/assets/images/step-schemas/bearing-surface-1.png';
import Bearing2 from '@/assets/images/step-schemas/bearing-surface-2.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeWizardSurface',
  emits: ['requestNextStep'],
  setup(__props) {

const { translate } = useTranslateEnums();



const surfaceStepStore = useSurfaceStepStore();

const surfaceGenericTypeOptions = computed((): Array<TranslateElement> => {
  return translate(SurfaceGenericType, 'surface.diameters');
});

const { t } = useI18n();

const externalDiameterLabel = computed((): string => {
  return `${t('surface.external_diameter', { value: surfaceStepStore.roundedExternalBearingDiameter })}mm`;
});
const internalDiameterLabel = computed((): string => {
  return `${t('surface.internal_diameter', { value: surfaceStepStore.roundedInnerBearingDiameter })}mm`;
});

const onInputInfoClick = async (header: string) => {
  const alert = await alertController.create({
    header,
    subHeader: undefined,
    message: undefined,
    buttons: [t('close')],
  });

  await alert.present();
};

const onGenericTypeChange = () => {
  surfaceStepStore.onGenericTypeUpdate();
};

const onUpdateInnerBearingDiameterChange = () => {
  surfaceStepStore.onSpecificInnerBearingDiameterUpdate();
};

const onExternalBearingDiameterChange = () => {
  surfaceStepStore.onSpecificExternalBearingDiameterUpdate();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputeWizardStepContainer, { class: "compute-wizard-surface" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonText), { class: "compute-wizard-surface__label compute-wizard-surface__label--bold compute-wizard-surface__label--alone" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(externalDiameterLabel.value), 1)
        ]),
        _: 1
      }),
      _createVNode(SegmentSelect, {
        onOnChange: onGenericTypeChange,
        options: surfaceGenericTypeOptions.value,
        modelValue: _unref(surfaceStepStore).genericType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(surfaceStepStore).genericType) = $event))
      }, null, 8, ["options", "modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonText), { class: "compute-wizard-surface__label compute-wizard-surface__label--bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(internalDiameterLabel.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonText), { class: "compute-wizard-surface__label compute-wizard-surface__label--description" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('surface.internal_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("img", {
        class: "compute-wizard-surface__image",
        src: _unref(Bearing1)
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        class: "compute-wizard-surface__image",
        src: _unref(Bearing2)
      }, null, 8, _hoisted_3),
      _createVNode(ComputeWizardInputAccordion, {
        class: "compute-wizard-surface__input-accordion",
        title: _ctx.$t('surface.specific_settings.accordion_label')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), {
            lines: "full",
            class: "compute-wizard-surface__input-accordion-item",
            slot: "content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), {
                class: "compute-wizard-surface__input-label",
                position: "stacked"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('surface.specific_settings.inner_bearing_diameter_input_label')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                class: "compute-wizard-surface__input",
                type: "number",
                inputMode: "decimal",
                pattern: "[0-9]*",
                modelValue: _unref(surfaceStepStore).specificInnerBearingDiameter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(surfaceStepStore).specificInnerBearingDiameter) = $event)),
                step: _unref(surfaceStepStore).specificInnerBearingDiameterStep,
                min: _unref(surfaceStepStore).specificInnerBearingDiameterMinValue,
                max: _unref(surfaceStepStore).specificInnerBearingDiameterMaxValue,
                placeholder: _ctx.$t('surface.specific_settings.inner_bearing_diameter_input_placeholder'),
                onIonChange: onUpdateInnerBearingDiameterChange
              }, null, 8, ["modelValue", "step", "min", "max", "placeholder"]),
              _createVNode(BaseButton, {
                class: "compute-wizard-surface__input-action",
                slot: "end",
                color: "light",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onInputInfoClick(_ctx.$t('surface.alert.inner_bearing_message'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    class: "compute-wizard-surface__input-action-icon",
                    icon: _unref(Icons).Info
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            lines: "full",
            class: "compute-wizard-surface__input-accordion-item",
            slot: "content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), {
                class: "compute-wizard-surface__input-label",
                position: "stacked"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('surface.specific_settings.external_bearing_diameter_input_label')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                class: "compute-wizard-surface__input",
                type: "number",
                inputMode: "decimal",
                pattern: "[0-9]*",
                step: _unref(surfaceStepStore).specificExternalBearingDiameterStep,
                min: _unref(surfaceStepStore).specificExternalBearingDiameterMinValue,
                max: _unref(surfaceStepStore).specificExternalBearingDiameterMaxValue,
                modelValue: _unref(surfaceStepStore).specificExternalBearingDiameter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(surfaceStepStore).specificExternalBearingDiameter) = $event)),
                enterkeyhint: "done",
                placeholder: _ctx.$t('surface.specific_settings.external_bearing_diameter_input_placeholder'),
                onIonChange: onExternalBearingDiameterChange,
                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('requestNextStep')), ["enter"]))
              }, null, 8, ["step", "min", "max", "modelValue", "placeholder"]),
              _createVNode(BaseButton, {
                class: "compute-wizard-surface__input-action",
                slot: "end",
                color: "light",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (onInputInfoClick(_ctx.$t('surface.alert.external_bearing_message'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    class: "compute-wizard-surface__input-action-icon",
                    icon: _unref(Icons).Info
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})